import QuickFilter from "@common/QuickFilter";
import {groupedValues, nonGroupedValues} from "@common/FilterComponent";

export interface QuickFilterInterface {
  displayText: string;
  key: string;
  value: nonGroupedValues | groupedValues | null;
}

type Props = {
  quickFilters: QuickFilterInterface[];
  activeFilter?: QuickFilterInterface | null;
  filterFunction: (filter: QuickFilterInterface) => void;
}

const QuickFilterBar = (props: Props) => {
  const handleClick = (filter: QuickFilterInterface) => {
    props.filterFunction(filter);
  };

  return (
    <>
      { props.quickFilters.map((filter, index) => {
        return (
          <QuickFilter
            key={index}
            onClick={() => handleClick(filter)}
            negated={filter.displayText !== props.activeFilter?.displayText}
          >
            {filter.displayText}
          </QuickFilter>
        );
      }
      )}
    </>
  );
};

export default QuickFilterBar;
